export default __webpack_public_path__ + "static/media/tutoriales_aviso.28deab48.png";